import React from 'react';
import { Redirect } from 'react-router-dom';
import withUser from './withUser';
import withTracker from '../withTracker';

class Logout extends React.Component {
  render() {
    return <Redirect to="/login" />;
  }

  componentDidMount() {
    this.props.logout('admin');
  }
}

export default withUser(withTracker(Logout));



// WEBPACK FOOTER //
// ./src/components/auth/Logout.js